/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_Src_1_NameInputs */

const en_wb_operations_src_1_name = /** @type {(inputs: Wb_Operations_Src_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer order email`)
};

const lv_wb_operations_src_1_name = /** @type {(inputs: Wb_Operations_Src_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klienta pasūtījuma e-pasts`)
};

/**
* | output |
* | --- |
* | "Customer order email" |
*
* @param {Wb_Operations_Src_1_NameInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_src_1_name = /** @type {((inputs?: Wb_Operations_Src_1_NameInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_Src_1_NameInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_src_1_name(inputs)
	return en_wb_operations_src_1_name(inputs)
});